import Svg, { Circle, Line, Path } from 'react-native-svg';

type Props = {
  size?: number;
  color?: string;
  waveColors?: readonly [string, string, string];
};

const wave = (y: number) =>
  `M6 ${y}c3 0 3-2.5 6-2.5S15 ${y} 18 ${y}s3-2.5 6-2.5S27 ${y} 30 ${y}s3-2.5 6-2.5S39 ${y} 42 ${y}`;

export function RivieraLogo({
  size = 36,
  color = '#c7a35c',
  waveColors = ['#8fc6c2', '#4f82b4', '#1f3864'],
}: Props) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round">
      <Circle cx={24} cy={16} r={5.5} />
      <Line x1={24} y1={3} x2={24} y2={6} />
      <Line x1={24} y1={26} x2={24} y2={29} />
      <Line x1={11} y1={16} x2={14} y2={16} />
      <Line x1={34} y1={16} x2={37} y2={16} />
      <Line x1={15} y1={7} x2={17} y2={9} />
      <Line x1={31} y1={23} x2={33} y2={25} />
      <Line x1={33} y1={7} x2={31} y2={9} />
      <Line x1={17} y1={23} x2={15} y2={25} />
      <Path d={wave(35)} stroke={waveColors[0]} />
      <Path d={wave(40)} stroke={waveColors[1]} />
      <Path d={wave(45)} stroke={waveColors[2]} />
    </Svg>
  );
}
